import { render, staticRenderFns } from "./bar-order-constructor-categorys.vue?vue&type=template&id=074b4bba&"
import script from "./bar-order-constructor-categorys.vue?vue&type=script&lang=ts&"
export * from "./bar-order-constructor-categorys.vue?vue&type=script&lang=ts&"
import style0 from "./bar-order-constructor-categorys.vue?vue&type=style&index=0&id=074b4bba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports